module.exports = __webpack_public_path__ + "img/024-shopping-cart.7072b02e.svg";